<template>
  <div class="invited-form-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-icon">🤝</div>
          <div class="header-text">
            <h2>邀请我管理的表格</h2>
            <p>查看和管理他人授权给您的表格</p>
          </div>
        </div>

        <!-- 提示横幅 -->
        <div class="notice-banner">
          <i class="el-icon-info"></i>
          <span>这里显示的表格是发表人邀请您围观的表格，类似于发表人授权您可以查看的表格</span>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
          <el-table border :data="tableData" stripe class="custom-table"
            :header-cell-style="{background:'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',color:'#1a1a1a',fontWeight:'600'}">
            <el-table-column type="index" label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                <span class="index-badge">{{scope.$index + 1}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="form_name" label="表格名称" min-width="200">
              <template slot-scope="scope">
                <div class="form-name">
                  <i class="el-icon-document"></i>
                  <span>{{scope.row.form_name}}</span>
                </div>
              </template>
            </el-table-column>



            <el-table-column prop="id" label="表格ID" width="80" align="center">
              <template slot-scope="scope">
                <span class="id-text">{{scope.row.id}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="state" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.state===1" class="tag-badge tag-pending">未发放</span>
                <span v-if="scope.row.state===2" class="tag-badge tag-active">正在填写</span>
                <span v-if="scope.row.state===100" class="tag-badge tag-completed">已收回</span>
              </template>
            </el-table-column>

            <el-table-column prop="submit_count" label="数据(条)" align="center" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.submit_count===0" class="tag-badge tag-empty">空表</span>
                <span v-else class="data-count">{{scope.row.submit_count}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="创建时间" align="center" width="170">
              <template slot-scope="scope">
                <span class="time-text">
                  <i class="el-icon-time"></i>
                  {{scope.row.create_time}}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="input_pages" :formatter="convertPages" label="填写张数" width="90" header-align="center" align="center">
              <template slot-scope="scope">
                <span class="pages-text">{{convertPages(scope.row)}}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="140" fixed="right">
              <template slot-scope="scope">
                <el-dropdown trigger="click" @command="handleCommand($event, scope.$index, scope.row)">
                  <el-button type="text" class="action-btn">
                    <i class="el-icon-s-operation"></i> 操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="action-dropdown">
            <!--        <el-dropdown-item v-if="scope.row.form_owner=='我的'" command="send">
                      <i class="el-icon-position"></i> 发放表格
                    </el-dropdown-item> -->
                    <el-dropdown-item command="browse">
                      <i class="el-icon-view"></i> 浏览数据
                    </el-dropdown-item>
                    <!-- <el-dropdown-item v-if="scope.row.form_owner=='我的'" command="tackback">
                      <i class="el-icon-refresh-left"></i> 收回表格
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.form_owner=='我的'" command="delete" divided>
                      <i class="el-icon-delete"></i> 删除表格
                    </el-dropdown-item>
                    <el-dropdown-item command="export">
                      <i class="el-icon-download"></i> 导出{{scope.row.file_type}}
                    </el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>

          <!-- 空状态 -->
          <div v-if="tableData.length === 0" class="empty-state">
            <i class="el-icon-document-delete"></i>
            <p>暂无邀请管理的表格</p>
            <span>当别人邀请您管理表格时，将在这里显示</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 重要提示弹窗 -->
    <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title warning">
        <i class="el-icon-warning"></i>
        <span>重要提示</span>
      </div>
      <div class="dialog-body">
        <p class="dialog-msg">{{msg}}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-danger-custom" @click="delFormContentRecord">删 除</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- Excel文件下载弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadExcelDialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-download"></i>
        <span>下载Excel文件</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📊</div>
        <p class="download-text">Excel文件已经生成</p>
        <p class="download-tip">请点击下载按钮获取文件</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadExcel">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadExcelDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- Zip文件下载弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadZipDialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-download"></i>
        <span>下载压缩包文件</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📦</div>
        <p class="download-text">压缩包文件已经生成</p>
        <p class="download-tip">下载后请用解压工具打开</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadZip">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadZipDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- PDF文件下载弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="downloadPDFDialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-download"></i>
        <span>下载PDF文件</span>
      </div>
      <div class="dialog-body center">
        <div class="download-icon">📄</div>
        <p class="download-text">PDF文件已经生成</p>
        <p class="download-tip">请点击下载按钮获取文件</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="downloadPDF">
          <i class="el-icon-download"></i> 下 载
        </el-button>
        <el-button @click="downloadPDFDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 发放表格弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="sendFormDialogVisible" custom-class="custom-dialog" width="600px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-position"></i>
        <span>发放表格</span>
      </div>
      <div class="dialog-body">
        <div class="instruction-text">
          发放表格需要在手机上操作，请用微信扫描下面的二维码打开多人填表小程序，在"更多功能"连接电脑后发放表格。
        </div>
        <div class="qrcode-section">
          <div class="qrcode-box">
            <img src="../assets/duorentianbiao-wx.jpg" class="qrcode-img" />
          </div>
          <div class="steps-list">
            <div class="step-title">操作步骤:</div>
            <div class="step-item">
              <span class="step-num">1</span>
              <span>用微信扫上面的码打开多人填表</span>
            </div>
            <div class="step-item">
              <span class="step-num">2</span>
              <span>如果没有连接电脑，在手机上多人填表右下角点击"更多功能"，再点"电脑互联"按照提示连接；如已经连接跳过本步骤</span>
            </div>
            <div class="step-item">
              <span class="step-num">3</span>
              <span>在手机多人填表小程序下边点"发出的表"找到《{{selected_form_name}}》并点击</span>
            </div>
            <div class="step-item">
              <span class="step-num">4</span>
              <span>点表格下面的"点我发放"或"点我重发"发送给填表人或群中即可</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendFormDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 下一步怎么办弹窗 -->
    <el-dialog :visible.sync="howToNextStepDialogVisible" custom-class="custom-dialog" width="550px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-question"></i>
        <span>表格导好了，下一步怎么办？</span>
      </div>
      <div class="dialog-body">
        <div class="steps-flow">
          <div class="flow-item">
            <div class="flow-icon">1</div>
            <div class="flow-text">打开您刚才扫码登录的小程序，您会看到刚才导入的表格</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">2</div>
            <div class="flow-text">在手机小程序上点表格打开并点"发放表格"发放表格</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">3</div>
            <div class="flow-text">填表人填写数据</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="howToNextStepDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 邀请围观弹窗 -->
    <el-dialog :visible.sync="howToUseInviteFormDialogVisible" custom-class="custom-dialog" width="550px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-share"></i>
        <span>怎么让别人看到我发的表格？</span>
      </div>
      <div class="dialog-body">
        <div class="steps-flow">
          <div class="flow-item">
            <div class="flow-icon">1</div>
            <div class="flow-text">打开您刚才扫码登录的小程序</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">2</div>
            <div class="flow-text">在手机小程序上点开您想让他看到的表格</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">3</div>
            <div class="flow-text">点击"邀请围观"把他邀请进来</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">4</div>
            <div class="flow-text">他用小程序扫web网站上的登录二维码登录网页端就可以看到表格了</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="howToUseInviteFormDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog :visible.sync="deleteFormConfirmDialogVisible" custom-class="custom-dialog" width="450px">
      <div slot="title" class="dialog-title danger">
        <i class="el-icon-delete-solid"></i>
        <span>删除确认</span>
      </div>
      <div class="dialog-body">
        <div class="delete-warning">
          <i class="el-icon-warning-outline"></i>
          <p>{{msg}}</p>
        </div>
        <div class="verify-section">
          <p class="verify-title">为了确保您不会误操作，请输入删除验证码</p>
          <div class="verify-code">
            <span class="code-label">删除验证码:</span>
            <span class="code-value">{{random_num}}</span>
          </div>
          <div class="verify-input">
            <span class="input-label">请输入验证码:</span>
            <el-input v-model="tmp_random_num" placeholder="请输入验证码" size="medium" class="code-input"></el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-danger-custom" @click="deleteSelectedForm">删除</el-button>
        <el-button @click="deleteFormConfirmDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,
        shownotify: 0,
        successDialogVisible: false,
        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,
        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',
        downloadPDFDialogVisible: false,
        howToNextStepDialogVisible: false,
        zip_file_form_id: '',
        howToUseInviteFormDialogVisible: false,
        deleteFormConfirmDialogVisible: false,
        random_num: '',
        tmp_random_num: ''
      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME')
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME')
      this.loadData()
    },
    methods: {
      handleCommand(command, index, row) {
        switch(command) {
          case 'send':
            this.sendForm(index, [row])
            break
          case 'browse':
            this.browseData(index, [row])
            break
          case 'tackback':
            this.tackbackForm(index, [row])
            break
          case 'delete':
            this.deleteForm(index, [row])
            break
          case 'export':
            this.exportToFile(index, [row])
            break
        }
      },
      loadData() {
        console.log('加载数据')
        let that = this
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_load_invited_forms.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.tableData = response.data
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state
        if (typeof (state) === 'undefined' || state === 1) {
          return '未发放'
        }
        if (state === 2) {
          return '正在填写'
        }
        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages
        if (typeof (inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }
        if (inputPages > 1) {
          return '多张/人'
        }
      },
      viewExam(index, rows) {
        var examID = rows[index].id
        var exam = rows[index].exam
        console.log('查看成绩单:' + exam)
        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id
        this.position = index
        this.selected_form_id = rows[index].id
        var state = rows[index].state
        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写，如要删除，请先收回表格！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })
          return
        }
        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据，删除前确保已经备份好了数据。如已备份且确实需要删除，请输入删除验证码后点"删除"，否则请点击"取消"!'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }
        this.deleteFormConfirmDialogVisible = true
      },
      deleteSelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入删除验证码!')
          return
        }
        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('删除验证码不正确，请重新输入!')
        } else {
          this.delFormContentRecord()
        }
      },
      delFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      tackbackForm(index, rows) {
        let that = this
        this.position = index
        this.selected_form_id = rows[index].id
        this.msg = '收回表格会停止填写表格，尚未填写的将不能继续填写，如要填写需要重新发放，要收回表格吗?'
        that.$confirm(this.msg, '操作提示', {
          confirmButtonText: '全部收回',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/form/web/_tack_back_form.jsp'
          that.axios.get(requestUrl, {
              params: {
                form_id: that.selected_form_id
              }
            }).then(function(response) {
              that.loadData()
              that.$message.success('收回成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {})
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this
        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },
      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this
        this.position = index
        this.selectedExamID = rows[index].id
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '生成文件中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            that.current_download_file_name = fileName
            that.zip_file_form_id = formId
          }
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id
        let that = this
        const load = this.$loading({
          lock: true,
          text: '生成PDF中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = '/form/web/_export_to_pdf.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true
          that.current_download_file_name = response.data.pdf_filename
          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadZip() {
        this.downloadZipDialogVisible = false
        var url = '/form/download.jsp?form_id=' + this.zip_file_form_id
        window.open(url)
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.sendFormDialogVisible = true
      },
      browseData(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name
        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      openMakeForm() {
        this.$router.push('/make_form')
      },
      validCondition(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name
        console.log(rows[index])
        console.log(formId)
        console.log(formName)
        this.$router.push({
          name: 'set_valid_condition',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      whatIsNextStep() {
        this.howToNextStepDialogVisible = true
      },
      collectAdvice(index, rows) {},
      howToUseInviteForm() {
        this.howToUseInviteFormDialogVisible = true
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .invited-form-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-icon {
    font-size: 42px;
    margin-right: 18px;
  }

  .header-text h2 {
    font-size: 24px;
    color: #1a1a1a;
    margin: 0 0 6px;
    font-weight: 600;
  }

  .header-text p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 提示横幅 */
  .notice-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%);
    border-left: 4px solid #FFCB2F;
    border-radius: 8px;
    margin-bottom: 25px;
    font-size: 14px;
    color: #8b6914;
  }

  .notice-banner i {
    font-size: 18px;
    color: #FFCB2F;
  }

  /* 表格区域 */
  .table-section {
    margin-top: 10px;
  }

  .custom-table {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }

  /* 序号徽章 */
  .index-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
  }

  /* 表格名称 */
  .form-name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: #1a1a1a;
  }

  .form-name i {
    color: #1485FB;
    font-size: 16px;
  }

  /* 状态标签 */
  .tag-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }

  .tag-pending {
    background: #fff7e6;
    color: #fa8c16;
    border: 1px solid #ffd591;
  }

  .tag-active {
    background: #e6f7ff;
    color: #1485FB;
    border: 1px solid #91d5ff;
  }

  .tag-completed {
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }

  .tag-empty {
    background: #fff1f0;
    color: #ff4d4f;
    border: 1px solid #ffa39e;
  }

  .tag-direct {
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }

  /* ID样式 */
  .id-text {
    color: #888;
    font-size: 13px;
    font-family: monospace;
  }

  /* 查询条件 */
  .condition-text {
    font-size: 12px;
    color: #666;
  }

  .condition-value {
    color: #1485FB;
    font-weight: 500;
    margin-top: 2px;
  }

  /* 数据条数 */
  .data-count {
    display: inline-block;
    padding: 4px 12px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    min-width: 30px;
  }

  /* 时间样式 */
  .time-text {
    color: #666;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  .time-text i {
    color: #ccc;
  }

  /* 填写张数 */
  .pages-text {
    color: #555;
    font-size: 13px;
  }

  /* 操作按钮 */
  .action-btn {
    color: #1485FB;
    font-weight: 500;
    font-size: 14px;
  }

  .action-btn:hover {
    color: #0d6efd;
  }

  .action-btn i {
    margin-right: 4px;
  }

  /* 下拉菜单 */
  .action-dropdown .el-dropdown-menu__item {
    padding: 8px 20px;
    font-size: 13px;
  }

  .action-dropdown .el-dropdown-menu__item i {
    margin-right: 8px;
    font-size: 14px;
  }

  /* 空状态 */
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    color: #999;
  }

  .empty-state i {
    font-size: 64px;
    color: #ddd;
    margin-bottom: 20px;
  }

  .empty-state p {
    font-size: 16px;
    color: #666;
    margin: 0 0 10px;
  }

  .empty-state span {
    font-size: 13px;
    color: #999;
  }

  /* ==================== 弹窗样式 ==================== */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 0;
  }

  ::v-deep .custom-dialog .el-dialog__header.warning {
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
  }

  ::v-deep .custom-dialog .el-dialog__header.danger {
    background: linear-gradient(135deg, #ff4d4f 0%, #f5222d 100%);
  }

  .dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .dialog-title i {
    font-size: 20px;
  }

  .dialog-title.warning,
  .dialog-title.danger {
    background: none;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 30px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 20px 30px;
  }

  .dialog-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .dialog-body.center {
    text-align: center;
  }

  .dialog-msg {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    margin: 0;
  }

  /* 下载弹窗 */
  .download-icon {
    font-size: 64px;
    margin-bottom: 20px;
  }

  .download-text {
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 600;
    margin: 0 0 10px;
  }

  .download-tip {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 发放表格弹窗 */
  .instruction-text {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    margin-bottom: 25px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 3px solid #1485FB;
  }

  .qrcode-section {
    display: flex;
    gap: 30px;
  }

  .qrcode-box {
    flex-shrink: 0;
  }

  .qrcode-img {
    width: 180px;
    height: 180px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  }

  .steps-list {
    flex: 1;
  }

  .step-title {
    font-weight: 600;
    font-size: 15px;
    color: #1a1a1a;
    margin-bottom: 15px;
  }

  .step-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #555;
    line-height: 1.6;
  }

  .step-num {
    width: 22px;
    height: 22px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  /* 流程步骤 */
  .steps-flow {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }

  .flow-item {
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    padding: 15px 20px;
    background: #f8f9fa;
    border-radius: 10px;
  }

  .flow-icon {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .flow-text {
    font-size: 14px;
    color: #555;
    line-height: 1.5;
  }

  .flow-arrow {
    margin: 10px 0;
    color: #ccc;
    font-size: 20px;
  }

  /* 删除确认弹窗 */
  .delete-warning {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 15px;
    background: #fff1f0;
    border-radius: 8px;
    margin-bottom: 20px;
    border-left: 3px solid #ff4d4f;
  }

  .delete-warning i {
    font-size: 20px;
    color: #ff4d4f;
    flex-shrink: 0;
  }

  .delete-warning p {
    margin: 0;
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  .verify-section {
    padding: 0 10px;
  }

  .verify-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
  }

  .verify-code {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
    padding: 12px 15px;
    background: #f8f9fa;
    border-radius: 8px;
  }

  .code-label {
    font-size: 14px;
    color: #666;
  }

  .code-value {
    font-size: 20px;
    color: #ff4d4f;
    font-weight: 700;
    letter-spacing: 3px;
    font-family: monospace;
  }

  .verify-input {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .input-label {
    font-size: 14px;
    color: #666;
    flex-shrink: 0;
  }

  .code-input {
    width: 150px;
  }

  /* 按钮样式 */
  .btn-primary-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.35);
    background: linear-gradient(135deg, #2d91fb 0%, #1a7cff 100%);
  }

  .btn-danger-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-danger-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 77, 79, 0.35);
    background: linear-gradient(135deg, #ff7875 0%, #ff5b5c 100%);
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }

    .qrcode-section {
      flex-direction: column;
      align-items: center;
    }

    .steps-list {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/invited_form_list.vue